function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipRule: "evenodd",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m512 128.533v-113.533c0-8.284-6.716-15-15-15h-482c-8.284 0-15 6.716-15 15v113.533zm-111.4-64.266c8.28 0 15 6.72 15 15 0 8.272-6.72 15-15 15-8.273 0-15-6.728-15-15 0-8.28 6.727-15 15-15zm-96.4 0c8.28 0 15 6.72 15 15 0 8.272-6.72 15-15 15-8.273 0-15-6.728-15-15 0-8.28 6.727-15 15-15zm-96.4 0c8.28 0 15 6.72 15 15 0 8.272-6.72 15-15 15-8.273 0-15-6.728-15-15 0-8.28 6.727-15 15-15zm-96.4 0c8.28 0 15 6.72 15 15 0 8.272-6.72 15-15 15-8.273 0-15-6.728-15-15 0-8.28 6.727-15 15-15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m417.733 417.733v-259.2h-323.466v259.2zm-274.2-224.933h224.934c8.284 0 15 6.716 15 15s-6.716 15-15 15h-224.934c-8.284 0-15-6.716-15-15s6.716-15 15-15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m447.733 158.533v274.2c0 8.284-6.716 15-15 15h-353.466c-8.284 0-15-6.716-15-15v-274.2h-64.267v338.467c0 8.284 6.716 15 15 15h482c8.284 0 15-6.716 15-15v-338.467z"
}));

function Svg75(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "inherit",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg75);
export default __webpack_public_path__ + "static/media/7_5.e3d1831c.svg";
export { ForwardRef as ReactComponent };